export enum DeviceType {
  UNKNOWN,
  MOBILE,
  TABLET,
  DESKTOP
}
